@if(showPatientSummary$()){
<ng-container>
    @if(content$ | async; as content){
    @if(patient$(); as patient){
    <div class="patient-summary-container"
        [class]="{'document-upload-standalone': isUploadDocument$() === 'Document Upload'}">
        @if(isMobile$())
        {
        <section class="patient-summary-detail">
            <article class="patient-name data-item">
                <span class="item-title" data-testid="patient-name">Patient</span>
                <span class="item-desc" data-testid="name">{{patient.lastName }}, {{patient.firstName }}</span>
            </article>
            <article class="dob data-item">
                <span class="item-title">Date of Birth</span>
                <span class="item-desc">{{ patient.dob.toLocaleString("en-US", { timeZone: 'UTC'}) | date
                    :'MM/dd/yyyy'}} </span>
            </article>
        </section>
        }
        @else {
        <section class="data-section">
            <article class="patient-name">
                <img [src]="content.image.url" [alt]="content.image.placeholder" class="patient-icon" data-testid="img">
                <span class="patient-first-last" data-testid="name">{{patient.lastName }}, {{patient.firstName }}</span>
            </article>
            <article class="data-item dob">
                <span class="item-title">Date of Birth</span>
                <span class="item-desc" data-testid="dob">{{ patient.dob.toLocaleString("en-US", { timeZone: 'UTC'}) |
                    date :'MM/dd/yyyy'}} </span>
            </article>
            @if(isUploadDocument$() !== 'Document Upload') {
            <article class="data-item sex">
                <span class="item-title">Sex</span>
                <span class="item-desc" data-testid="sex">{{patient.sex }}</span>
            </article>
            <ng-container>
                @if(products$(); as products){
                @if(products.length > 0){
                <article class="data-item product">
                    <span class="item-title">{{products.length > 1 ? 'Products' : 'Product'}}</span>
                    <span class="item-desc" data-testid="product">
                        @for(product of products; track $index){
                        {{$last ? product : product + ','}}
                        }
                    </span>
                </article>
                }
                }
            </ng-container>
            }
        </section>
        }
    </div>
    }
    }
</ng-container>
}